module.exports = __webpack_public_path__ + "static/media/pagcorlogo2.4196aac2.svg";